<template>
  <div v-if="items.length > 0" class="informative-services mt-4">
    <div class="informative-services__header">
      <i class="fas fa-info-circle mr-2"></i>
      Venda única
      <span class="badge badge-warning ml-2">Não cobrados na fatura</span>
    </div>
    <div class="informative-services__body">
      <div
        v-for="detail in items"
        class="input-group mb-2"
        :key="detail.type_id"
      >
        <div class="input-group-prepend">
          <span class="input-group-text informative-services__label">
            {{ detail.title }}
          </span>
        </div>
        <money
          v-bind="money"
          class="form-control m-input"
          v-model="detail.details[0].price"
        ></money>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

// Serviços com billable = 0 (ex.: Setup e Replace de número): o valor fica no
// contrato só para consulta e o faturamento ignora. O pai carrega os dados de
// service/informative/data e os envia junto no save dos serviços.
export default {
  name: 'ContractInformativeServices',
  components: { Money },
  props: {
    services: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  computed: {
    items() {
      return Object.values(this.services || {});
    },
  },
};
</script>

<style scoped>
.informative-services__header {
  padding: 0.75rem 0;
  font-weight: 600;
  color: #000;
}

.informative-services__label {
  min-width: 190px;
  color: #000;
}
</style>
